import React from "react";

// One-line reason shown on a connector this installation cannot reach (Restricted / AirGapped
// deployment profiles; availability comes from useModuleAvailability). The card stays visible,
// its outbound controls are disabled, and this line says why.
export const UNAVAILABLE_TEXT = "Not available on this installation (no internet access).";

export default function UnavailableNote({ className = "" }) {
  return (
    <p className={`text-xs text-gray-500 ${className}`.trim()} data-testid="unavailable-note">
      {UNAVAILABLE_TEXT}
    </p>
  );
}
